import React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import SchemaOrg from './schemaOrg'

export const SEO_FIELDS = graphql`
  fragment SeoFields on WpContentNode {
    ... on WpPage {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
    ... on WpPost {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
    ... on WpProductguide {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
    ... on WpCasestudy {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
    ... on WpInfographic {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
    ... on WpCareer {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
    ... on WpNew {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
    ... on WpThankyou {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
    ... on WpTool {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
    ... on WpWebinar {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
    ... on WpWhitepaper {
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
      }
    }
  }
`

function SEO({
  seo = null,
  desc = null,
  pageTitle = null,
  url = null,
  featuredImage = null,
  isBlogPost = false,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            company
            siteUrl
            author
            fbId
          }
        }
      }
    `
  )

  const title = seo?.title || pageTitle
  const company = site?.siteMetadata.company
  const description = desc ? desc : seo?.metaDesc
  const canonicalUrl =
    url && url.replace('wp.marketware.com', 'marketware.com') /* TODO: better fix on wp side*/
  const lang = 'en'
  const locale = 'en_US'
  const image = featuredImage || null
  const opengraphAuthor = seo?.opengraphAuthor || null
  const opengraphTitle = seo?.opengraphTitle || null
  const opengraphSiteName = seo?.opengraphSiteName || null
  const opengraphDescription = seo?.opengraphDescription || description
  const opengraphUrl = canonicalUrl || seo?.opengraphUrl || null
  const opengraphImage = seo?.opengraphImage?.sourceUrl || image || ''
  const opengraphImageAlt = seo?.opengraphImage?.altText || ''
  const opengraphType = 'website'
  const opengraphDatePublished = seo?.opengraphPublishedTime || null
  const fbId = site?.siteMetadata.fbId
  const twitterCreator = site?.siteMetadata?.author
  const twitterTitle = seo?.twitterTitle || null
  const twitterDescription = seo?.twitterDescription || null
  const twitterImage = seo?.twitterImage?.sourceUrl || null

  return (
    <React.Fragment>
      <Helmet htmlAttributes={{ lang: lang }}>
        {/* General tags */}
        <title>{title}</title>
        <meta name='robots' content='index' />
        {description && <meta name='description' content={description} />}
        {image && <meta name='image' content={image} />}
        {canonicalUrl && <link rel='canonical' href={canonicalUrl} />}

        {/* link preconnects */}
        <link rel='preconnect' href='https://www.facebook.com'></link>
        <link rel='preconnect' href='https://stats.g.doubleclick.net'></link>
        <link rel='preconnect' href='https://www.googleadservices.com'></link>
        <link rel='preconnect' href='https://www.google-analytics.com'></link>
        <link rel='preconnect' href='https://connect.facebook.net'></link>
        <link rel='preconnect' href='https://www.googletagmanager.com'></link>

        {/* OpenGraph tags */}
        {opengraphUrl && <meta property='og:url' content={opengraphUrl} />}
        {locale && <meta property='og:locale' content={locale} />}
        {opengraphType && <meta property='og:type' content={opengraphType} />}
        {opengraphAuthor && <meta property='og:author' content={opengraphAuthor} />}
        {opengraphTitle && <meta property='og:title' content={opengraphTitle} />}
        {opengraphSiteName && <meta property='og:site_name' content={opengraphSiteName} />}
        {opengraphDescription && <meta property='og:description' content={opengraphDescription} />}
        {opengraphImage && <meta property='og:image' content={opengraphImage} />}
        {opengraphImageAlt && <meta property='og:image:alt' content={opengraphImageAlt} />}
        {fbId && <meta property='fb:app_id' content={fbId} />}

        {/* Twitter Card tags */}
        <meta name='twitter:card' content='summary_large_image' />
        {twitterCreator && <meta name='twitter:creator' content={twitterCreator} />}
        {twitterTitle && <meta name='twitter:title' content={twitterTitle} />}
        {twitterDescription && <meta name='twitter:description' content={twitterDescription} />}
        {twitterImage && <meta name='twitter:image' content={twitterImage} />}
      </Helmet>
      <SchemaOrg
        author={company}
        canonicalUrl={canonicalUrl}
        title={title}
        datePublished={opengraphDatePublished}
        description={description}
        url={url}
        organization={company}
        image={opengraphImage}
        defaultTitle={title}
        isBlogPost={isBlogPost}
      />
    </React.Fragment>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

export default SEO
